import {
  CreateAgendaSlotBulkApiResponseError,
  CreateWorkScheduleSlotBulkApiResponseError,
} from '@omecare/utils';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { CreateAgendaSlotBulkListReport } from './create-agenda-slot-bulk-list-report';
import {
  CreateAgendaSlotBulkReportModalApi,
  useCreateAgendaSlotBulkReportModalApiViewModel,
} from './create-agenda-slot-bulk-report-modal.viewmodel';

export const CreateAgendaSlotBulkReportModal = ({
  report,
  officeId,
  onClose,
}: CreateAgendaSlotBulkReportModalApi & {
  officeId: string;
  report: {
    error:
      | CreateWorkScheduleSlotBulkApiResponseError
      | CreateAgendaSlotBulkApiResponseError;
  };
}) => {
  const { t } = useTranslation();
  const viewModel = useCreateAgendaSlotBulkReportModalApiViewModel({
    api: {
      onClose,
    },
  });

  const contentByErrorType: ReactNode = (() => {
    if (report.error.error === 'create_agenda_slot_bulk_report_error') {
      return (
        <div className="flex flex-col gap-2">
          {report.error.data.slotsInformation.length > 0 && (
            <CreateAgendaSlotBulkListReport
              title={t(
                'create-agenda-slot-bulk-report-modal.create-agenda-slot-bulk-report-error.title',
              )}
              slotsInformation={report.error.data.slotsInformation}
              officeId={officeId}
            />
          )}
        </div>
      );
    }

    return null;
  })();

  return (
    <Dialog
      open={true}
      onOpenChange={(open) => {
        if (!open) viewModel.api.close();
      }}
    >
      <DialogContent
        className="sm:max-w-2xl"
        showCloseButton={false}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>
            {t('create-agenda-slot-bulk-report-modal.title')}
          </DialogTitle>
          <DialogDescription>
            {t('create-agenda-slot-bulk-report-modal.description')}
          </DialogDescription>
        </DialogHeader>

        {contentByErrorType}

        <DialogFooter>
          <Button
            variant="secondary"
            onClick={viewModel.api.close}
          >
            {t('btn.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
